import "./componentPlaceholder.css";

import PropTypes from "prop-types";

/*
 * Basic placeholder with big icon and display text
 */
export const ComponentPlaceholder = ({ icon, text, size = "fa-5x" }) => {
  return (
    <div className="component-placeholder">
      <i className={`${size} ${icon} discrete-icon`} />
      {text}
    </div>
  );
};

ComponentPlaceholder.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.string,
  size: PropTypes.string,
};
